interface IENV {
  appCode: string;
  apiEndpoint: string;
  envType?: string;
  portalGetway: string;
  /** chat-service through the gateway, for the topbar's Chat launcher. Empty = no launcher. */
  chatGetway: string;
  hrmGetway: string;
  portalURL?: string;
  /**
   * Origin of `portalURL` — the Portal host, for cross-app links such as the module switcher.
   * Derived once here rather than at each call site, which is how two of those links ended up
   * hardcoded to portal.erpboi.com. Empty string when portalURL is unset or malformed.
   */
  portalOrigin: string;
  /**
   * Vendor credit at the left of every page's footer in a client-side PDF export. Per INSTALL
   * (set in environments/.env.*), the counterpart of store-service's `pdf.brand_footer_text`.
   * Empty prints no line — deliberately no literal fallback, which would stamp one vendor's
   * name on the other install's exports.
   */
  pdfBrandFooterText: string;
}

const originOf = (url?: string): string => {
  try {
    return new URL(url || '').origin
  } catch {
    return ''
  }
}

export const ENV: IENV = {
  appCode: process.env.REACT_APP_CODE || '',
  envType: process.env.REACT_APP_ENV_TYPE || '',
  apiEndpoint: process.env.REACT_APP_GETWAY || '',
  portalURL: process.env.REACT_APP_PORTAL_URL || '',
  portalOrigin: originOf(process.env.REACT_APP_PORTAL_URL),
  portalGetway: process.env.REACT_APP_PORTAL_GETWAY || '',
  chatGetway: process.env.REACT_APP_CHAT_GETWAY || '',
  hrmGetway: process.env.REACT_APP_HRM_GETWAY || '',
  pdfBrandFooterText: (process.env.REACT_APP_PDF_BRAND_FOOTER_TEXT || '').trim(),
};
